export type APIErrorData = {
  statusCode: number;
  error: string;
  message: string;
  nodeId?: string;
  commonTriggers?: [];
};

export default class APIError extends Error {
  statusCode: number;
  error: string;
  nodeId?: string;
  commonTriggers?: [];

  constructor({
    statusCode,
    error,
    message,
    nodeId,
    commonTriggers,
  }: APIErrorData) {
    super(message);
    this.statusCode = statusCode;
    this.error = error;
    this.nodeId = nodeId;
    this.commonTriggers = commonTriggers;
  }
}
